import { ChristmasProjects } from 'PARTIALS/christmas';
import { qq, q } from 'bobjoll/ts/library/dom';
import { KEventTarget, KEvent } from 'bobjoll/ts/library/event';

require('./style');
require('./helpers');

const URL_STATIC_IMG = '/img';

export class ChristmasBanner extends KEventTarget {
    options: ChristmasBannerOptions;
    cookieName: string;
    bannerElement: HTMLElement;
    template = require('PARTIALS/christmas/banner/banner.hbs');

    constructor(options: ChristmasBannerOptions) {
        super();
        this.options = options;
        this.setup();
    }

    addEventListener(type: 'banner:show', listener: (ev: KEventShow) => any, useCapture?: boolean): void;
    addEventListener(type: 'banner:hide', listener: (ev: KEventHide) => any, useCapture?: boolean): void;
    addEventListener(type: string, listener: (ev: KEvent) => any, useCapture: boolean = true): void {
        super.addEventListener(type, listener, useCapture);
    }

    private setup() {
        document.body.insertAdjacentHTML('beforeend', this.template({ ...this.options, URL_STATIC_IMG }));
        const bannerElement = q('.christmas-banner');
        if (bannerElement) {
            this.bannerElement = bannerElement;
            qq('.christmas-banner__toggle').forEach(buttonElement => buttonElement.addEventListener('click', () => this.toggle()));
            qq('.christmas-banner__close').forEach(buttonElement => buttonElement.addEventListener('click', () => this.close()));
        }
    }

    public toggle() {
        this.bannerElement.classList.toggle('show');
        this.dispatchEvent(
            this.bannerElement.classList.contains('show')
                ? new KEventShow(this.bannerElement)
                : new KEventHide(this.bannerElement)
        );
    }

    public close() {
        this.toggle();
    }
}

export interface ChristmasBannerOptions {
    project: ChristmasProjects;
    text: {
        condition: string;
        description: string;
        price: string;
        title?: string;
        url: string;
    };
    logo?: boolean;
    url: string;
    week?: number;
}

export class KEventShow extends KEvent {
    constructor(bannerElement: HTMLElement) {
        super();
        this.type = 'banner:show';
        this.extra = bannerElement;
    }
}

export class KEventHide extends KEvent {
    constructor(bannerElement: HTMLElement) {
        super();
        this.type = 'banner:hide';
        this.extra = bannerElement;
    }
}
